import React from 'react'
import { useDispatch } from 'react-redux'
import { isReactNativeApp, subscribeToNative } from '@mobi/web-native-comms/web'
import { setBetSlipIsOpen } from '@core/Areas/AppHeader/Store'

export const useNativeNavCloseBetSlip = (isOpen: boolean) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!isReactNativeApp || !isOpen) return undefined

    const closeBetSlip = () => dispatch(setBetSlipIsOpen(false))

    const abortController = new AbortController()
    const cleanupSignal = abortController.signal

    subscribeToNative('VISION_FLOAT_TOGGLE', closeBetSlip, { cleanupSignal })
    subscribeToNative('NAVIGATE_WEB_SPORTS', closeBetSlip, { cleanupSignal })
    subscribeToNative('NAVIGATE_WEB_RACES', closeBetSlip, { cleanupSignal })
    subscribeToNative('DEEP_LINK_OPEN', closeBetSlip, { cleanupSignal })

    return () => abortController.abort()
  }, [dispatch, isOpen])
}
